import * as qiniu from "qiniu-js";
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from "uuid";
import { getQiniuGptTokenApi } from "../api/chatApi.js";
import { formatTime } from "@/utils/file";
import { getFileSuffixByType } from "@/utils/file/file.js";

// 获取七牛token
export async function getQiniuToken() {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const res = await getQiniuGptTokenApi();
      // const data = config.decrypt(res).data;
      const token = res.token;
      resolve(token);
    } catch (e) {
      reject(e);
    }
  });
}

// 上传文件到七牛获取返回值
export async function getQiniuUrl(file, keyPrefix = "", fileName = "") {
  keyPrefix = keyPrefix || "project/file/";
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getQiniuToken();
      let filesuffix = "";
      // 如果名字有 . 认为文件名自带后缀
      if (!fileName.includes(".")) {
        filesuffix = getFileSuffixByType(file.type) || file.type?.split("/")[1];
      }
      const key = `${keyPrefix}${formatTime(1)}/`;
      const fileNameStr = `${uuidv4()}${fileName ? `---${fileName}` : ""}`;
      const suffix = `${filesuffix ? `.${filesuffix}` : ""}`;
      const uploadKey = key + fileNameStr + suffix;
      console.log("key uploadKey", uploadKey);
      const observable = qiniu.upload(
        file,
        uploadKey,
        token,
        {},
        { useCdnDomain: false, region: qiniu.region.z2 }
      );

      observable.subscribe({
        next: () => {
          //
        },
        error: (err) => {
          reject(err.message);
        },
        complete: (res) => {
          resolve(res);
        },
      });
    } catch (e) {
      reject(e);
    }
  });
}

export async function getQiNiuUploadFileUrl(file, key, fileName) {
  const qiniuResult = await getQiniuUrl(file, key, fileName);
  const qiniuUrl = `https://123botcdn.pcdashi.cn/${qiniuResult.key}`;
  return qiniuUrl;
}
